import React, { useEffect, useState } from "react";
import * as S from "./styles";
import QRCode from "react-qr-code";
import logo from "@/assets/svgs/logo.svg";
import { toast } from "react-toastify";
import RoundInput from "@/components/RoundInput";
import { FutButton } from "@/components/FutButton";
import { MdOutlineCopyAll } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { api } from "@/services/api";
import { getCookie } from "@/utils/cookies";
import { plans, plansPrices } from "@/constants/plans";

import { ReactComponent as SuccessSvg } from "@/assets/svgs/success-circle.svg";

export default function PixScreen() {
  const [values, setValues] = useState({
    userId: 0,
    planType: "",
    pixKey: "",
    active: false,
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      try {
        const cookie = getCookie("payment_data");
        const cookieValue: typeof values = cookie
          ? JSON.parse(cookie)
          : undefined;

        const userSignature = await api.get(
          `/user/checkPayment/${cookieValue.userId}`
        );

        const pixKey = await api.post("/payment/checkout", {
          userId: cookieValue.userId,
          subscriptionId: plans[cookieValue.planType as keyof typeof plans],
          type_payment: "PIX",
        });

        if (!cookieValue) {
          navigate("/login");
          return;
        }

        setValues({
          userId: cookieValue.userId,
          planType: cookieValue.planType,
          pixKey: pixKey.data.qrcode,
          active: userSignature.data.active,
        });
        setLoading(false);
      } catch (e) {
        navigate("/login");
      }
    };

    init();
  }, []);
  return (
    <>
      <S.Navigation>
        <img src={logo} alt="Futscore" />
        <S.LoginButton variant="outlined" onClick={() => navigate("/login")}>
          Entrar
        </S.LoginButton>
      </S.Navigation>
      <S.BackgroundVector />
      <S.MethodsWrapper>
        <S.MethodsContainer>
          {loading ? (
            <CircularProgress />
          ) : values.active ? (
            <S.SuccessContainer>
              <SuccessSvg />
              <h2>Pix Realizado com sucesso!</h2>
              <S.LoginButton
                variant="outlined"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => navigate("/login")}
              >
                Entrar
              </S.LoginButton>
            </S.SuccessContainer>
          ) : (
            <>
              <S.PixQrContainer>
                <p>
                  Preço do plano{" "}
                  {plansPrices[values.planType as keyof typeof plansPrices]}
                </p>
                <QRCode value={values.pixKey} />

                <S.CopyPixContainer>
                  <RoundInput size="small" readOnly value={values.pixKey} />
                  <FutButton
                    variant="text"
                    onClick={() => {
                      navigator.clipboard.writeText(values.pixKey);
                      toast.success("Copiado com sucesso!");
                    }}
                  >
                    <MdOutlineCopyAll /> Copiar Código
                  </FutButton>
                </S.CopyPixContainer>
              </S.PixQrContainer>
              <S.PixStepsContainer>
                <div>
                  <span>1</span> <p>Abra o app do seu seu banco</p>
                </div>
              </S.PixStepsContainer>
              <S.PixStepsContainer>
                <div>
                  <span>2</span>
                  <p>Scaneie o qr code ou copie o código acima</p>
                </div>
              </S.PixStepsContainer>
              <S.PixStepsContainer>
                <div>
                  <span>3</span>
                  <p>Após o pagamento clique em entrar para acessar o Futscore</p>
                </div>
              </S.PixStepsContainer>
            </>
          )}
        </S.MethodsContainer>
      </S.MethodsWrapper>
    </>
  );
}
